module.exports = __webpack_public_path__ + "static/3-e5d6b91f9275a1935666d11fa53ab721.png";